import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import {
  PORTFOLIO_ACCESS,
  type PortfolioAccess,
} from 'lumen/components/settings/currency-conversion/profile';
import type { CurrencyConversionExchangeRatesProfile } from 'lumen/models';
import type HotelSettingsCurrencyConversionProfileRoute from 'lumen/routes/hotel/settings/currency-conversion/profile';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsCurrencyConversionProfileController extends Controller {
  declare model: ModelFrom<HotelSettingsCurrencyConversionProfileRoute>;

  @service declare access: Services['access'];
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;
  @service declare router: Services['router'];

  get exchangeRatesProfile(): CurrencyConversionExchangeRatesProfile | null {
    return this.model.exchangeRatesProfile.last?.value ?? null;
  }

  get portfolioAccess(): PortfolioAccess | null {
    if (!this.hotelAndMarketService.hotel?.spiderMarketId) {
      return null;
    }
    return this.access.hasCurrencyConversionEditAccess
      ? PORTFOLIO_ACCESS.EDIT
      : PORTFOLIO_ACCESS.VIEW;
  }

  @action
  navigateToPortfolio(): void {
    // spiderMarketId is guaranteed non-null when portfolioAccess is set
    void this.router.transitionTo(
      'market.settings.currency-conversion.profile',
      this.hotelAndMarketService.hotel.spiderMarketId!,
      this.exchangeRatesProfile!.id,
    );
  }
}
